import { useRef } from "react";

import { useReactiveVar } from "@apollo/client";

import { sessionExpiredVar } from "@/client/session-guard-vars";

/**
 * Reports that this tab has LOST a session it previously held.
 *
 * `currentUserId` is the identity this tab knows about. Seeing any id at all is
 * recorded, once, as proof this tab was authenticated at some point. A tab that
 * never had a session — an unauthenticated cold load, where CurrentUser 401s
 * before any identity resolves — has not had one replaced, and keeps the app's
 * existing not-logged-in handling.
 */
export function useSessionGuard(currentUserId: string | undefined): boolean {
  const expired = useReactiveVar(sessionExpiredVar);

  const wasAuthenticated = useRef(false);
  if (currentUserId !== undefined) wasAuthenticated.current = true;

  return expired && wasAuthenticated.current;
}
